import { render, staticRenderFns } from "./user_mng_page.vue?vue&type=template&id=0c5e224a"
import script from "./user_mng_page.vue?vue&type=script&lang=js"
export * from "./user_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5e224a')) {
      api.createRecord('0c5e224a', component.options)
    } else {
      api.reload('0c5e224a', component.options)
    }
    module.hot.accept("./user_mng_page.vue?vue&type=template&id=0c5e224a", function () {
      api.rerender('0c5e224a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/user/user_mng_page.vue"
export default component.exports